import { createSlice } from '@reduxjs/toolkit'

const customBenefitPaymentSlice = createSlice({
    name: 'benefit-payment',
    initialState: { account: '', pin: '' },
    reducers: {
        setAccount(state, action) {
            const { payload } = action

            state.account = payload
        },
        setPin(state, action) {
            const { payload } = action
            state.pin = payload
        },
    },
})

const { actions, reducer } = customBenefitPaymentSlice

export const { setAccount, setPin } = actions

export default reducer
